import React, { useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import constants from "../../utils/constants";
import { useEffect } from "react";
import obj from "../../utils/constants";
import { isEmpty } from "lodash";
import { Helmet } from "react-helmet";
const ViewDialogNew = ({ object, onHide, setObject }) => {
  const params = useParams();
  const [isLoader, setLoader] = useState(false);
  const [matchData, setMatchData] = useState([]);
  const [total, setTotal] = useState([]);
  const [detailsData, setDetailsData] = useState({});
  const [search_params, setSearchParams] = useState({
    userId: object?.userId,
    userType: object?.userType,
    eventId: object?.id,
    marketId: object?.marketId,
    betType: "betFair",
  });

  function mergeAndSumPositions(data) {
    const merged = data
      .flatMap((item) => item.position)
      .reduce((acc, curr) => {
        const key = curr.selectionId;
        if (!acc[key]) {
          acc[key] = { ...curr };
        } else {
          acc[key].positionLoseAmount += curr.positionLoseAmount;
          acc[key].positionProfitAmount += curr.positionProfitAmount;
          acc[key].position += curr.position;
        }
        return acc;
      }, {});

    return Object.values(merged);
  }

  const getMatchData = async () => {
    setLoader(true);

    const { status, data: response_users } = await apiGet(
      apiPath.downlineDataRisk,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setLoader(false);
          setTotal(
            mergeAndSumPositions(response_users.results)?.sort((a, b) => {
              return parseInt(a.selectionId) - parseInt(b.selectionId);
            })
          );
          setMatchData(response_users.results);
        }
      }
    }
  };

  const setFunc = (object) => {
    if (!isEmpty(object)) {
      setSearchParams({
        userId: object?.userId,
        userType: object?.userType,
        eventId: object?.id,
        marketId: object?.marketId,
        betType: "betFair",
      });
    }
  };
  useEffect(() => {
    setFunc(object);
  }, [object]);

  useEffect(() => {
    getMatchData();
    getDetails();
  }, [object?.userId, object?.eventId, object?.betType, object?.marketId]);

  useEffect(() => {
    const intervalID = setInterval(() => {
      getMatchData();
      getDetails();
    }, 10 * 1000);
    return () => clearInterval(intervalID);
  }, [object?.userId, object?.eventId, object?.betType]);

  const getDetails = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.riskManagementDetails +
        `?eventId=${search_params.eventId}&marketId=${search_params?.marketId}`
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setDetailsData(response_users.results);
        }
      }
    }
  };
  return (
    <div className="risk-popup">
      <Modal size="2xl" centered show={true} onHide={onHide}>
        <Modal.Body>
          <section className="account-table risk-pop">
            <div className="container-fluid px-0">
              <div className="db-sec d-flex justify-content-between align-items-center mb-2">
                <h2 className="common-heading">
                  {detailsData?.eventName} ( {object?.title} )
                </h2>
                <Button className="green-btn" onClick={() => onHide()}>
                  X
                </Button>
              </div>
              {matchData?.length > 0 && (
                <div className="responsive">
                  <Table>
                    <thead>
                      <tr>
                        <th scope="col">Downline</th>{" "}
                        {detailsData?.jsonData
                          ?.sort((a, b) => {
                            return (
                              parseInt(a.SelectionId) - parseInt(b.SelectionId)
                            );
                          })
                          ?.map((res) => {
                            return <th scope="col">{res?.RunnerName}</th>;
                          })}
                      </tr>
                    </thead>
                    {!isLoader ? (
                      <tbody>
                        {matchData &&
                          matchData?.length > 0 &&
                          matchData?.map((res) => {
                            return (
                              <>
                                <tr>
                                  <td className="text-start">
                                    {search_params?.userType == "agent" ? (
                                      <>
                                        <a href={"#"} className="text-primary">
                                          <span>
                                            {
                                              constants?.user_status[
                                                res?.userType || ""
                                              ]
                                            }
                                          </span>
                                        </a>
                                        {res?.username || null}
                                      </>
                                    ) : (
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          setObject({
                                            userId: res?._id,
                                            userType: res?.userType,
                                            id: search_params?.eventId,
                                            title: object?.title,
                                            marketId: search_params?.marketId,
                                            checkType: "new",
                                          });
                                          setFunc({
                                            userId: res?._id,
                                            userType: res?.userType,
                                            id: search_params?.eventId,
                                            title: object?.title,
                                            marketId: search_params?.marketId,
                                            checkType: "new",
                                          });
                                        }}
                                      >
                                        <a href={"#"} className="text-primary">
                                          <span>
                                            {
                                              constants?.user_status[
                                                res?.userType || ""
                                              ]
                                            }
                                          </span>
                                        </a>
                                        {res?.username || null}
                                      </Link>
                                    )}
                                  </td>
                                  {res?.position
                                    ?.sort((a, b) => {
                                      return (
                                        parseInt(a.selectionId) -
                                        parseInt(b.selectionId)
                                      );
                                    })
                                    ?.map((item) => {
                                      return (
                                        <td>
                                          {Math.sign(
                                            item?.position?.toFixed(2)
                                          ) === -1 ? (
                                            search_params?.userType ==
                                            "agent" ? (
                                              <span className="text-danger">
                                                {item?.position?.toFixed(2)}
                                              </span>
                                            ) : (
                                              <span className="text-success">
                                                {Math.abs(
                                                  item?.position?.toFixed(2)
                                                )}
                                              </span>
                                            )
                                          ) : search_params?.userType ==
                                            "agent" ? (
                                            <span className="text-success">
                                              {item?.position?.toFixed(2)}
                                            </span>
                                          ) : (
                                            <span className="text-danger">
                                              {item?.position?.toFixed(2)}
                                            </span>
                                          )}
                                        </td>
                                      );
                                    })}
                                </tr>
                              </>
                            );
                          })}
                        {matchData?.length > 0 && (
                          <tr style={{ fontWeight: "600" }}>
                            <td className="text-start">Total</td>
                            {total?.map((res) => {
                              return (
                                <td>
                                  {Math.sign(res?.position?.toFixed(2)) ===
                                  -1 ? (
                                    search_params?.userType == "agent" ? (
                                      <span className="text-danger">
                                        {res?.position?.toFixed(2)}
                                      </span>
                                    ) : (
                                      <span className="text-success">
                                        {Math.abs(res?.position?.toFixed(2))}
                                      </span>
                                    )
                                  ) : search_params?.userType == "agent" ? (
                                    <span className="text-success">
                                      {res?.position?.toFixed(2)}
                                    </span>
                                  ) : (
                                    <span className="text-danger">
                                      {res?.position?.toFixed(2)}
                                    </span>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        )}

                        {isEmpty(matchData) ? (
                          <tr>
                            <td colSpan={9}>No records found</td>
                          </tr>
                        ) : null}
                      </tbody>
                    ) : (
                      <div
                        id="loader"
                        className="spinner"
                        style={{ display: `block` }}
                      ></div>
                    )}
                  </Table>
                </div>
              )}
            </div>
          </section>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewDialogNew;
